<template>
  <div class="overall2 HEIGHTAUTO">
    <div class="overall2_case" style="display: flex; align-items: center; justify-content: center">
      <CCascader
        style="margin-left: 10px"
        @CCascader_select_node="fnCCascader_select_val_chart3"
        :default="category_cascader_val_chart3"
        :checkStrictly="true"
        :multiple="true"
        :collapsetags="true"
        :options="category_cascader_options"
        ref="sb1"
        >选择类别
      </CCascader>
      <CCascader
        style="margin-left: 10px"
        :checkStrictly="false"
        :multiple="true"
        :isDelete="false"
        :default="reit_code"
        placeholder="请选择个股"
        :collapsetags="true"
        wide
        @CCascader_select_val="fnSelect_select_val_chart1_codename"
        :options="CODENAMEDATA">
        选择对比REITs
      </CCascader>
      <span class="oneyear">
        以1开始
        <el-checkbox @change="fnGetCalSingleReitIndexByOne" v-model="checked_one"></el-checkbox>
      </span>
    </div>
    <div
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)"
      class="echarts_AREA">
      <div class="canvasArea3" v-for="(node, index) in dCalSingleReitIndex_Ys" :key="index">
        <div :id="'c2623' + node.name" style="height: 300px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { fnReturnTableStyle } from '@/utils/util';
import CCascader from '@/components/Basic/CCascader';
import { sleep } from '../../../utils';

export default {
  name: 'SubSectionSingle',
  components: { CCascader },
  data() {
    const CATEGORYDATA = JSON.parse(localStorage.getItem('FINALLYCATEGORY')) || [];
    const REITsNAME = JSON.parse(localStorage.getItem('REITsNAME2')) || [];
    const CODELIST = JSON.parse(localStorage.getItem('CODELIST')) || [];

    const CODEMAP = {};
    CODELIST.forEach((item) => {
      CODEMAP[item.reitCode] = item;
    });
    return {
      CODEMAP: Object.freeze(CODEMAP),
      CATEGORYDATA: Object.freeze(CATEGORYDATA),
      sCurrentTheme: this.$store.state.theme == 'dark' ? true : false,
      ROOTFONTFIZE: '',

      loading: false,
      dCalSingleReitIndex_Ys: [],

      CODENAMEDATA: Object.freeze(REITsNAME),
      category_cascader_val_chart3: ['公募REITs'],
      category_cascader_options: Object.freeze(CATEGORYDATA),
      reit_code: [],
      checked_one: false,

      timer: null,
      timer2: null,
    };
  },
  methods: {
    // 获取当前屏幕宽度
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;

      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;

      window.sessionStorage.setItem('ROOTFONTFIZE', this.ROOTFONTFIZE);
      return;
    },
    resize() {
      this.fnGetWidth();
    },
    styleBindFun() {
      let val = this.$store.state.theme == 'dark' ? true : false;
      return fnReturnTableStyle(val);
    },
    fnGetTheme() {
      console.log('fnGetTheme index');
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    fnSelect_select_val_chart1_codename(val) {
      val = val.filter((node) => {
        return node.includes('.');
      });

      this.reit_code = Object.freeze(val);
      this.fnGetCalSingleReitIndex(1);
    },
    fnCCascader_select_val_chart2(val) {
      if (!val) {
        this.fnGetCalSingleReitIndex(1);
        return;
      }
      const CATEGORYDATA = this.CATEGORYDATA;

      // 递归查找目标节点路径
      const findPath = (nodes, targetLabel) => {
        for (const node of nodes) {
          if (node.label === targetLabel) return [node.value];
          if (node.children) {
            const path = findPath(node.children, targetLabel);
            if (path) return [node.value, ...path];
          }
        }
        return null;
      };

      const path = findPath(CATEGORYDATA, val);
      const item = path ? [path] : [[val]];

      setTimeout(() => {
        this.$refs.sb1.value = item;
        this.$refs.sb1.handleChange(item);
      }, 0);
    },
    fnCCascader_select_val_chart3(val) {
      if (!val.length) {
        this.$message.error('请选择类别');
        return;
      }
      this.category_cascader_val_chart3 = val;
      this.fnGetCalSingleReitIndex(1);
    },
    fnGetCalSingleReitIndexByOne() {
      this.fnGetCalSingleReitIndex(1);
    },
    async fnGetCalSingleReitIndex(flag = false) {
      if (flag) {
        this.timer && clearInterval(this.timer);
        this.timer2 && clearTimeout(this.timer2);
      }
      this.loading = true;
      var r_type = this.category_cascader_val_chart3 || [];
      // console.log("TTTTTTTTTTT",r_type);
      let str = r_type.join('&r_type=');
      let codes = this.reit_code || [];
      let str2 = codes.join('&codes=');
      const turn_index = this.checked_one ? 1 : 0;
      // const { data } = await this.$https.get(
      const { data } = await this.$inday.get(
        /* `/api/v2_5/reit_category_single_inday_index?limit=100&r_type=${str}&codes=${str2}&turn_index=${turn_index}` */
        `/api/board/single-inday-index?r_type=${str}&codes=${str2}&turn_index=${turn_index}`
      );
      if (data.code !== 200) return this.$message.error(data.msg);

      let dataTmp = data.data;

      // 步骤1：提取x轴数据,并且提取最大值以及最小值
      let max = 0;
      let min = 20000;
      let arrX = [];

      dataTmp.forEach((node) => {
        arrX.push(node.tr_date);
        for (var key in node) {
          if (key == 'tr_date') {
            continue;
          }
          if (node[key] == '') {
            return;
          }
          if (key != '中证REITs（全收益）' && !this.checked_one && node[key] > 500) {
            continue;
          }
          if (node[key] >= max) {
            max = node[key];
          }
          if (node[key] <= min) {
            min = node[key];
          }
        }
      });
      this.max = max.toFixed(4);
      this.min = min.toFixed(4);

      // 步骤2：提取值作为y轴数据，组成一组数据
      // let arr2 = Object.keys(dataTmp[0]);
      // arr2.shift(); // 改变一下这个顺序即可
      let arr2 = [];
      if (dataTmp != undefined && dataTmp.length > 0) {
        arr2 = Object.entries(dataTmp[dataTmp.length - 1]);
        arr2.shift();
      }

      arr2.sort((val1, val2) => {
        return val2[1] - val1[1];
      });
      arr2 = arr2.map((node) => {
        return node[0];
      });

      let FINALLYDATA = [];
      arr2.forEach((node) => {
        let obj = {
          key: node,
          data: [],
        };
        arrX.forEach((item) => {
          dataTmp.forEach((e) => {
            if (e.tr_date == item) {
              obj.data.push(e[node]);
            }
          });
        });

        FINALLYDATA.push(obj);
      });

      let FINALLYDATA_AFTER = [];
      arr2.forEach((node) => {
        let obj = {
          name: node,
          value: FINALLYDATA,
        };
        FINALLYDATA_AFTER.push(obj);
      });

      this.dCalSingleReitIndex_Ys = [];
      this.dCalSingleReitIndex_Ys = FINALLYDATA_AFTER.slice(0, 1000);

      this.chart6_arrX = arrX;
      this.initChart(flag);
    },

    initChart(flag) {
      const checked_one = this.checked_one;
      let FINALLYDATA_AFTER = this.dCalSingleReitIndex_Ys;
      let arrX = this.chart6_arrX;

      let COLORSARRAY = [
        {
          name: '中证REITs（全收益）',
          value: '#fff',
        },
        ...this.$store.state.colors,
      ];
      //

      let theme = this.$store.state.theme;
      setTimeout(() => {
        FINALLYDATA_AFTER.forEach((item, index) => {
          this.$nextTick(() => {
            if (!document.getElementById('c2623' + item.name)) {
              return;
            }
            const chartInstance = echarts.init(document.getElementById('c2623' + item.name));
            this.chartInstance = chartInstance;
            if (flag) {
              chartInstance.clear();
            }
            let seriesArr = item.value.map((node) => {
              if (!checked_one && node.key != item.name) {
                return;
              }
              const CODEMAP = this.CODEMAP;
              return {
                name: CODEMAP[node.key] ? CODEMAP[node.key]['reitsName'] : node.key,
                data: node.data,
                type: 'line',
                smooth: false,
                symbol: 'none',
                show: node.key == item.name ? true : false,
                tooltip: {
                  show: node.key == item.name ? true : false,
                },
              };
            });
            let colors = [];
            item.value.forEach((node, idx) => {
              if (!checked_one && node.key != item.name) {
                return;
              }
              const CODEMAP = this.CODEMAP;
              if (item.name == node.key) {
                let obj = COLORSARRAY.filter((node) => {
                  return (
                    node.name ==
                    (CODEMAP[item.name] ? CODEMAP[item.name]['reitsTypeL2'] : item.name)
                  );
                });
                if (item.name == '中证REITs（全收益）') {
                  if (theme == 'dark') {
                    colors.push('white');
                  } else {
                    colors.push('gray');
                  }
                } else {
                  colors.push(obj[0].value);
                }
              } else {
                if (theme == 'dark') {
                  colors.push('rgba(118, 118, 118, 0.1)');
                } else {
                  colors.push('rgba(196, 196, 196, 0.1)');
                }
              }
            });

            seriesArr = seriesArr.filter((item) => item != undefined);
            colors = colors.filter((item) => item != undefined);
            var data_min = 20000;
            if (!checked_one) {
              data_min = seriesArr[0]['data']
                .filter((item) => typeof item === 'number')
                .reduce((a, b) => Math.min(a, b));
            }
            if (item.name == '中证REITs（全收益）') {
              console.log('colors', seriesArr, colors);
            }

            let OPTIONDATA =
              this.$store.state.theme == 'dark'
                ? this.$store.state.OPTIONDATA
                : this.$store.state.OPTIONDATA_light;

            let option = {
              grid: {
                left: this.ROOTFONTFIZE * (50 / 144),
                bottom: this.ROOTFONTFIZE * (40 / 144),
              },
              tooltip: {
                trigger: 'axis',
                confine: true,
                triggerOn: 'mousemove|click', // 触发时机, click代表点击, mouseOver代表鼠标移过
                formatter: (val) => {
                  const CODEMAP = this.CODEMAP;
                  let str = '';
                  val.forEach((node) => {
                    if (node.value == '') {
                      return;
                    }

                    let val = Number(node.value).toFixed(4);
                    // let val = node.value;
                    str += `${node.axisValueLabel}`;
                    str += '<br>';
                    str += `${node.marker}${
                      CODEMAP[item.name] ? CODEMAP[item.name]['reitsName'] : item.name
                    }:   ${val}`;
                  });

                  return str;
                },
              },
              title: {
                text: this.CODEMAP[item.name] ? this.CODEMAP[item.name]['reitsName'] : item.name, // 标题文字
                textStyle: {
                  color: OPTIONDATA.title.textStyle.color,
                  fontSize: this.ROOTFONTFIZE * (16 / 144),
                },
                top: this.ROOTFONTFIZE * (20 / 144),
                left: this.ROOTFONTFIZE * (20 / 144),
              },
              color: colors,
              xAxis: {
                type: 'category',
                data: arrX,
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                },
                axisLabel: {
                  show: false,
                },
              },
              yAxis: {
                type: 'value',
                axisLine: {
                  show: true,
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  show: true,
                  color: OPTIONDATA.xAxis.axisLabel.color,
                  fontSize: this.ROOTFONTFIZE * (12 / 144),
                },
                // max: this.max,
                // min: this.min,
              },
              series: seriesArr,
            };
            if (checked_one) {
              option.yAxis.max = this.max;
              option.yAxis.min = this.min;
            } else {
              option.yAxis.min = data_min;
            }

            chartInstance.setOption(option);
            this.loading = false;
          });
        });
      }, 500);
      this.flash();
    },
    flash() {
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.fnGetCalSingleReitIndex();
      }, 60000);
    },
  },
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
    this.timer2 && clearTimeout(this.timer2);
  },
  computed: {
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      this.styleBindFun();
      this.fnGetTheme();
      this.chartInstance && this.initChart();
    },
  },
};
</script>

<style scoped lang="less">
.overall2 {
  position: relative;
  width: 100%;
  background-color: var(--charts_bgc);

  height: auto;
  border-radius: calc(var(--ROOTFONTFIZE) * (20 / 144));
  box-sizing: border-box;
}
.chart_title {
  color: var(--chart_title);
  font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
  font-weight: 700;
  // border-left: 5px solid #1573fe;
  border-left: calc(var(--ROOTFONTFIZE) * (5 / 144)) solid var(--primary-color);
  padding-left: 18px;
  padding-left: calc(var(--ROOTFONTFIZE) * (18 / 144));
  height: calc(var(--ROOTFONTFIZE) * (28 / 144));
  display: flex;
  align-items: center;
}

.chart_title span {
  color: #1573fe;
}

.btnArea {
  display: flex;
  justify-content: center;
  margin-left: calc(var(--ROOTFONTFIZE) * (18 / 144));
}

.echarts_AREA {
  padding-left: calc(var(--ROOTFONTFIZE) * (50 / 144));
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
}

.canvasArea3 {
  width: 20%;
  //   margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  border: none;
}

.chart3_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.oneyear {
  margin-left: 10px;
  color: var(--legndAreaItem_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
}
.overall2_case {
  position: absolute;
  width: 50%;
  left: calc(var(--ROOTFONTFIZE) * (220 / 144));
  top: calc(var(--ROOTFONTFIZE) * (-35 / 144));
  z-index: 0;
}
</style>
